import React, { useEffect } from "react";
import avtar from "../../assets/images/avtar.jpg";
import { Link, useNavigate } from "react-router-dom";
// import DeleteToast from "../Users/DeleteToast";
import LogoutToast from "./LogoutToast";
import PasswordReset from "./PasswordReset";
import { baseUrl } from "../../config/baseUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
export default function Header() {
  let navigate = useNavigate();
  // let [deleteid, setDeleteid] = useState();
  // let [logout, setlogout] = useState(false);
  let token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, []);
  let UserDetails = JSON.parse(localStorage.getItem("user"));


  const removeClass = (e) => {
    document?.body?.classList?.toggle("resize-menu");
  };
  const handleError = (e) => {
    e.target.src = avtar;
  };
  // const logoutAuto = async () =>{
  //   localStorage.clear();
  //   navigate("/Login");
  //   toast.info("Your Session Expired")
  // }
  // useAutoLogout(logoutAuto)
  return (
    <>
      <header className="header">
        <div className="navbar-header">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-6 col-sm-6 col-6">
              <div className="header-fltr">
                <Link className="toggle fs-4" onClick={removeClass}>
                  <i className="fa fa-bars" />
                </Link>
                <form action="">
                  <div className="header-fltr-bx">
                    <div className="text-light fs-5">
                      {UserDetails?.libraryName}
                    </div>
                    <div className="prfl-bar">
                      <div className="prfl-bar-img">
                        <img
                          onError={handleError}
                          src={`${baseUrl}/${UserDetails?.libraryPhoto}`}
                          className="profle"
                          alt="profile_image"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-7 col-md-6 col-sm-6 col-6">
              <div className="app-header-right-side">
                {/* <ul className="app-header-right-side-list">
                  <li>
                    <Link to="">Help</Link>
                  </li>
                  <li>
                    <button type="button" className="position-relative">
                      <i className="fa fa-bell" />
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                        1
                      </span>
                    </button>
                  </li>
                </ul> */}
                <div className="prfl-bar">
                  <div className="prfl-bar-content">
                    <Link
                      data-bs-toggle="modal"
                      data-bs-target="#logout"
                      className="logout_btn"
                      title="LogOut"
                    >
                      <FontAwesomeIcon icon={faPowerOff} className="ms-2" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <LogoutToast />
      <PasswordReset />
      <style>
        {`
        .header-fltr-bx .prfl-bar .prfl-bar-img img {
            height: 45px;
            width: 45px;
            border-radius: 25px;
}
  .header-fltr-bx{
  display: flex;
  align-items: center;
  gap: 15px;
  flex-direction: row-reverse;
  }
  .prfl-bar-content .logout_btn{
          font-size:25px;
          color:#fff;
  }
        `}
      </style>
    </>
  );
}
